<script>

import {computed, ref, watch} from "vue";
import useSharedSelectData from "@/use/SharedSelectData";
import axios from "axios";
import {useClipboard} from "@/use/Clipboard";

export default {
    name: "StrHRVariables",
    props: {
        module: String,
    },
    setup(props, {emit}) {

        const {copyToClipboard} = useClipboard();
        const dialog = ref(false);

        const {
            variables,
            workerVariables,
            contratVariables,
            debtVariables,
            recruitmentRequestVariables,
            recruitmentPlanningVariables,
            recruitmentCvTechSourcingVariables,
            recruitmentCandidateVariables,
            boardingVariables,
            boardingTaskVariables,
            evaluationPlanVariables,
            evaluationCandidateVariables,
            medicalCompanionVariables,
            medicalAppointmentVariables,
        } = useSharedSelectData();

        const items = computed(() => {
            switch (props.module) {
                case 'RECRUITMENT_REQUEST':
                    return recruitmentRequestVariables;
                case 'RECRUITMENT_PLANNING':
                    return recruitmentPlanningVariables;
                case 'RECRUITMENT_CV_TECH_SOURCING':
                    return recruitmentCvTechSourcingVariables;
                case 'RECRUITMENT_CANDIDATE':
                    return recruitmentCandidateVariables;
                case 'BOARDING':
                    return boardingVariables;
                case 'BOARDING_TASK':
                    return boardingTaskVariables;
                case 'WORKER':
                    return workerVariables;
                case 'CONTRAT':
                    return contratVariables;
                case 'DEBT':
                case 'PAY_DAY_ADVANCE':
                    return debtVariables;
                case 'EVALUATION_PLAN':
                    return evaluationPlanVariables;
                case 'EVALUATION_CANDIDATE':
                    return evaluationCandidateVariables;
                case 'MEDICAL_COMPANION':
                    return medicalCompanionVariables;
                case 'MEDICAL_APPOINTMENT':
                    return medicalAppointmentVariables;
                default:
                    return variables;

            }
        });


        const personalizedVariables = ref([]);
        const loading = ref(false);

        function findPersonalizedVariables() {
            loading.value = true;
            axios.get('/personalizedVariables', {
                params: {
                    module: props.module,
                }
            }).then((response) => {
                personalizedVariables.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function addPersonalizedVariable(item) {
            let variable = '';
            if (item.activateNamedValue)
                variable += item.namedValue + ' ';
            variable += `[#${item.name}#]`
            addVariable(variable);
        }

        watch(() => props.module, () => {
            if (props.module)
                findPersonalizedVariables();
        }, {immediate: true});

        function addVariable(variable) {
            emit('addVariable', variable);
            copyToClipboard(variable);
            dialog.value = false;
        }

        return {
            dialog,
            loading,
            items,
            personalizedVariables,
            addPersonalizedVariable,
            addVariable
        }
    }
}

</script>

<template>
    <v-dialog
        v-model="dialog"
        width="400"
        scrollable
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="red"
                class="white--text"
                depressed
                small
                :loading="loading"
                v-bind="attrs"
                v-on="on"
            >
                Variables
                <v-icon right>mdi-application-variable</v-icon>
            </v-btn>
        </template>
        <v-card height="600">
            <w-toolbar color="red" :title="$t('common.variables')"/>
            <v-card-text>
                <v-list dense>
                    <div v-if="module === 'CONTRAT'">
                        <v-subheader>{{ $t('module.personalized_variable') }}</v-subheader>
                        <template v-for="(item, i) in personalizedVariables">
                            <v-list-item
                                :key="`p-item-${i}`"
                                @click="addPersonalizedVariable(item)"
                            >
                                <v-list-item-content>
                                    <v-list-item-title v-text="`[#${item.name}#]`"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider v-if="i < items.length - 1" :key="`p-divider-${i}`"/>
                        </template>
                    </div>
                    <v-subheader>{{ $t('common.by_default') }}</v-subheader>
                    <template v-for="(item, i) in items">
                        <v-list-item
                            :key="`item-${i}`"
                            @click="addVariable(item)"
                        >
                            <v-list-item-content>
                                <v-list-item-title v-text="item"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider v-if="i < items.length - 1" :key="`divider-${i}`"/>
                    </template>
                </v-list>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>